module.exports = __webpack_public_path__ + "img/5.aec477f7.jpg";